export default __webpack_public_path__ + "static/media/medaille-bdo-or-realisation.d12dc0c3.png";